module.exports = __webpack_public_path__ + "static/media/calculator-alt.dea1bfa3.svg";